module.exports = __webpack_public_path__ + "img/header_title_forecast@2x.f915ae43.png";